import { ReactNode } from 'react'
import { createPortal } from 'react-dom'

/**
 * @description Portal primitive to render children in a different stacking context (z-axis), to make sure that modal, etc. are truly on top of everything else.
 */
const Float = ({ children }: { children: ReactNode }) => {
  const root = document.getElementById('float-root')
  return root ? createPortal(children, root) : null
}

export default Float
